import {useMemo} from "react";

import {useGetClientInfoQuery} from "../../client/api/get_client_info";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useAppSelector} from "../../store/hooks";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {buildSurveySearchFormValues} from "../utils/build_recent_filters_search_values";
import {hasMainFiltersInUrl, useRecentFilters} from "./use_recent_filters";

/**
 * Shared hook for recent filters + survey preferences used by
 * RecentFiltersSearch, RecentFiltersRegions, RecentFiltersSidebar.
 */
export const useRecentFiltersWithSurvey = () => {
    const {recentFilters, latestQuery, shouldShow} = useRecentFilters();
    const currentFormValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;
    const {data: surveyData} = useGetClientInfoQuery();
    const surveyRegionIds = useMemo(() => surveyData?.regions || [], [surveyData?.regions]);
    const {data: surveyRegions} = useGetRegionDetailListQuery({regionIds: surveyRegionIds}, {skip: !surveyRegionIds.length});

    const hasSurveyFilters = !!(surveyData?.rooms?.lower || surveyData?.rooms?.upper || surveyData?.price?.lower || surveyData?.price?.upper);
    const shouldShowSurvey = hasSurveyFilters && !!surveyRegions?.length && !hasMainFiltersInUrl(latestQuery);
    const surveyFormValues = surveyData && surveyRegions ? buildSurveySearchFormValues(surveyData, surveyRegions) : null;

    return {
        recentFilters,
        latestQuery,
        shouldShow,
        surveyFormValues,
        shouldShowSurvey,
        currentFormValues
    };
};
import {useMemo} from "react";

import {useGetClientInfoQuery} from "../../client/api/get_client_info";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {useAppSelector} from "../../store/hooks";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {buildSurveySearchFormValues} from "../utils/build_recent_filters_search_values";
import {hasMainFiltersInUrl, useRecentFilters} from "./use_recent_filters";

/**
 * Shared hook for recent filters + survey preferences used by
 * RecentFiltersSearch, RecentFiltersRegions, RecentFiltersSidebar.
 */
export const useRecentFiltersWithSurvey = () => {
    const {recentFilters, latestQuery, shouldShow} = useRecentFilters();
    const currentFormValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;
    const {data: surveyData} = useGetClientInfoQuery();
    const surveyRegionIds = useMemo(() => surveyData?.regions || [], [surveyData?.regions]);
    const {data: surveyRegions} = useGetRegionDetailListQuery({regionIds: surveyRegionIds}, {skip: !surveyRegionIds.length});

    const hasSurveyFilters = !!(surveyData?.rooms?.lower || surveyData?.rooms?.upper || surveyData?.price?.lower || surveyData?.price?.upper);
    const shouldShowSurvey = hasSurveyFilters && !!surveyRegions?.length && !hasMainFiltersInUrl(latestQuery);
    const surveyFormValues = surveyData && surveyRegions ? buildSurveySearchFormValues(surveyData, surveyRegions) : null;

    return {
        recentFilters,
        latestQuery,
        shouldShow,
        surveyFormValues,
        shouldShowSurvey,
        currentFormValues
    };
};
